module.exports = __webpack_public_path__ + "media/components/images/panels/7-b-37c43e8f1264b6e3eb528b2664c6d5fc.jpeg";